__turbopack_context__.v({
  "empty": "PortalPosts-module__5cIo3W__empty",
  "feed": "PortalPosts-module__5cIo3W__feed",
  "feedHeading": "PortalPosts-module__5cIo3W__feedHeading",
  "loadMore": "PortalPosts-module__5cIo3W__loadMore",
  "primary": "PortalPosts-module__5cIo3W__primary",
  "secondary": "PortalPosts-module__5cIo3W__secondary",
  "stream": "PortalPosts-module__5cIo3W__stream",
});
